module.exports = __webpack_public_path__ + "static/img/20220127001.1607d5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20220127001.jpg
// module id = Q6NZ
// module chunks = 134